import { SWITCH_BUSINESS_INFO } from '../../utils/constants';
import { CUASTOMER_NATIONALITY_INFO } from './reducer';

const CURRENT_ACCOUNT_SWITCH = 'current account switch';
/**
 * To return data on basis of key
 * @param {object} state
 * @param {string} key
 */
export const getBusinessData = (state, key) => {
  const data = state.oldSignatories ? state.oldSignatories.toJS() : {};
  return data[key] || '';
};

export const getSignatoriesDataLength = (state, key) => {
  const data = state.oldSignatories ? state.oldSignatories.toJS() : {};
  return data[key] ? data[key].length : 0;
};

export const isCurrentAccountSwitch = state => {
  const data = state.oldSignatories ? state.oldSignatories.toJS() : {};
  return (
    data &&
    data[SWITCH_BUSINESS_INFO] &&
    data[SWITCH_BUSINESS_INFO].switchService &&
    data[SWITCH_BUSINESS_INFO].switchService.toLowerCase() === CURRENT_ACCOUNT_SWITCH
  );
};

export const getCustomerNationality = state => {
  const data = state.oldSignatories ? state.oldSignatories.toJS() : '';
  return data ? data[CUASTOMER_NATIONALITY_INFO] : {};
};
